<template>
  <div
    class="custom-message-component-column"
    :style="{...style}"
    @click="clickHandle"
  >
    <slot />
  </div>
</template>

<script lang="ts" >
import { CustomMessageColumnComponent } from '_c/typings/model/chat/text-node';
import { pushUrl } from '@/business/chat/custom-message-util';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'CustomMessageColumn',
  props: {
    attr: {
      type: Object as PropType<CustomMessageColumnComponent>,
      required: true,
    },
  },

  setup(props) {
    const style = {
      justifyContent: props.attr.mainAxisAlignment ?? 'center',
      alignItems: props.attr.crossAxisAlignment ?? 'start',
    };
    function clickHandle(e: Event): void {
      if (props.attr.onClick) {
        e.stopPropagation();
        pushUrl(props.attr.onClick, props.attr.reportData);
      }
    }
    return {
      style, clickHandle,
    };
  },

});

</script>
<style scoped lang='scss'>
.custom-message-component-column {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
